module.exports = __webpack_public_path__ + "img/traffic-junction-5.c754eae6.jpg";